import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import userService from "../../../services/user.service";
//  commom-email and phone number
import { emailAddress, phoneNumber } from "../../../common";
import backIcon from "../../../assets/images/public/back-icon.png";
import { ContactUsForm } from "./contactUsForm";
import { unFormatPhoneNumber } from "../../../Common/unFormatPhoneNumber";
import {
  openFailDialog,
  openSuccessPopup,
} from "../../../Redux/Actions/PopupActions";

class ContactUs extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      message: "",
      name: "",
      phoneNo: "",
      subject: "",
      headingContactUs: "",
      subheadingContactUs: "",
    };
  }

  componentDidMount() {
    if (document.getElementById("hideSAdminDash")) {
      document.getElementById("hideSAdminDash").style.display = "none";
      window.scrollTo(0, 0);
    }
    this.getContactUs();
  }

  getContactUs() {
    userService.getAllWebsiteContactUs().then((res) => {
      this.setState({
        headingContactUs:
          res.data.data.websiteContactUsDetailsResponses[0].heading,
        subheadingContactUs:
          res.data.data.websiteContactUsDetailsResponses[0].subHeading,
      });
    });
  }

  submitContactUs = (
    { name, email, message, subject, phoneNumber },
    resetForm
  ) => {
    const { setFailPopUpInformation, setSuccessPopupInformation } = this.props;
    setSuccessPopupInformation({
      successPopUp: {
        message: "Thank you for reach out to us. We will contact you soon.",
        open: true,
      },
    });
    resetForm({ values: "" });
    const phoneNo = unFormatPhoneNumber(phoneNumber);
    userService
      .postContactUs(email, message, name, phoneNo, subject)
      .then(() => {})
      .catch(() => {
        //Not showing error to outside user
        //added isMail column in database for mail tracking
      });
  };

  render() {
    const { email, message, name, phoneNo, subject, subheadingContactUs } =
      this.state;
    return (
      <>
        <section className="guidlelines-section">
          <div className="guidlelines-container signup-container">
            <div className="signup-back-title-container">
              <div className="screen-title-container signup-title-container contact-title-container">
                <div className="screen-title-content">
                  <Link className="back-button-container" to="/">
                    <img src={backIcon} alt="back" />
                  </Link>
                  <div>
                    Contact <span>Us</span>
                  </div>
                </div>
              </div>
              <div className="faq-section">
                <div>{subheadingContactUs}</div>
              </div>
            </div>
            <div className="signup-form-container">
              <ContactUsForm
                name={name}
                email={email}
                phoneNo={phoneNo}
                subject={subject}
                message={message}
                submitContactUs={this.submitContactUs}
              />
            </div>
          </div>
          <div className="guidlelines-container contact-us-footer-container">
            <div className="faq-support-container">
              If you have any questions, please reply to this email or contact
              us at: <br />
              <span>{emailAddress} </span> or <span>{phoneNumber}</span>
            </div>
          </div>
        </section>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return {
    state,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContactUs)
);
